
import { defineComponent, onMounted, reactive, watch, ref, nextTick, onBeforeUnmount, toRefs, unref,onDeactivated } from "vue";
import { useRouter, useRoute } from "vue-router";
import { robotsInfo, robotsWorkData, robotsUpdateName, robotsActiveCode, getStatusVs, getStatusDstic, getWorktime, getbuildingOrder, getTask, refresh_diag, refresh_info, refresh_version, robotSIM } from "@/apis/robot";
import  {getlogs,lastlogs,cancellogs} from  '@/apis/log'
import { ElMessageBox, ElMessage,ElForm, ElSteps } from "element-plus";
import formatTime from "../../utils/format"
import { useStore } from "@/store";
import {
  momentStamp,
} from "@/utils/robot";
import { hourList } from "@/utils/constant"
import { buildingListRequest, shopQuery, buildingRobotDelete, relationRobots, shopRobotDelete, shopRobotUpdate } from '@/apis/building'
import taskEcharts from './components/taskEcharts/index.vue'
import worktimeEcharts from './components/worktimeEcharts/index.vue'
import { getLanguage } from "@/utils/cookies";
import  noData  from "@/components/noData/noData.vue"
import {timeBlankSpaceFormat} from '@/utils/timeFormat'
import { ElLoading } from 'element-plus'

// 引入防抖 节流
import { debounce, throttle, forEach } from "lodash";
import { init, EChartsOption } from 'echarts'
import i18n from "@/locales";
import moment from 'moment'
import { Ref } from "vue-property-decorator";
const _t = i18n.global.t;
import { inputRules,inputLengthLimit } from '@/utils/validate'

let websocket: any = null;

export default defineComponent({
  components: {
    taskEcharts,
    worktimeEcharts,
    noData
  },
  setup() {
    const router = useRouter();
    const robot = useRoute();
    const userFormRef = ref(ElForm)
    const validatelogs = (rule: any, value: any, callback: any) => {
      if (!state.checked1 && !state.checked2 && !state.checked3 && !state.checked4 && state.checklogdown) {
        callback(new Error(_t('robotinfo.Plelogtype')))
      } else {
        callback()
      }
    };
    const validatelogsstatrtime = (rule: any, value: any, callback: any) => {
      if ((!state.logStartTime && state.checklogdown) || (!state.logStartHour && state.checklogdown)) {
        callback(new Error(_t('robotinfo.Plestartdateandtime')))
      } else {
        callback()
      }
    };
    const validatelogsendtime = (rule: any, value: any, callback: any) => {
      if ((!state.logEndTime && state.checklogdown) || (!state.logEndHour && state.checklogdown)) {
        callback(new Error(_t('robotinfo.Pleanenddateandtime')))
      } else {
        callback()
      }
    };
    const state = reactive({
      languageClassObj:{
        enStyle: false,
        koStyle: false,
        deStyle: false,
        frStyle: false,
        jaStyle: false,
        nlStyle: false,
        plStyle: true,
      },
      language: '',
      workTimeArr: [] as any,
      workDayArr: [] as any,
      workTimeMax: '' as any,
      lineChart: false,
      circular: false,
      robotState: '',
      normalURL: require('../../assets/images/public/normal.png'),
      abnormalURL: require('../../assets/images/public/abnormal.png'),
      robotBindDialog: false,
      cascaderValue: '',
      buildingShopData: [
        // {
        //   value: 'building',
        //   label: _t('buiding.buid'),
        //   children: [

        //   ],
        // },
        {
          value: 'shop',
          label: _t('buiding.shop'),
          children: [

          ],
        }
      ] as any,
      robotRelationParams: {     // 关联机器人和更换楼宇上送参数
        building_id: '',
        robots: ''
      },
      shopRelationParams: {     // 关联机器人和更换店铺上送参数
        shop_id: '',
        robots: ''
      },
      form: {
        name: ''
      }as any,
      logform: {
        logtype: '',
        starttime: '',
        endtime: ''
      },
      logrules: {
        logtype: [{
          validator: validatelogs, required: true,
        }],
        starttime: [{ validator: validatelogsstatrtime, required: true, }],
        endtime: [{ validator: validatelogsendtime, required: true, }],
      },
      labelRules:{
        name: [{ message: _t('public.rules.pleaseLabel'), required: true, }],
      },
      taskArr: [] as any,
      operatingData: '' as any, // 运行数据
      stateContent: '',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      robotName: '机器人',
      robotData: '' as any,
      robtBasicsInfo: '' as any,  // 基础信息
      stateColorOne: 'rgba(82, 196, 26, 0.15)', // 在线状态背景颜色
      stateBorderColorOne: '1px solid #52C41A', // 在线状态边框颜色
      stateSizeColorOne: '',  // 在线状态字体颜色
      stateSizeColorTwo: '#1890FF', // 工作中、空闲、充电等状态字体颜色
      stateColorTwo: 'rgba(24, 144, 255, 0.15)', // 工作中、空闲、充电等状态背景颜色
      stateBorderColorTwo: '1px solid #1890FF', // 工作中、空闲、充电等状态边框颜色
      BackGroundcolor: '#52C41A', // 电池颜色
      Batterys: '' as any,       // 充电状态下电量百分比
      chargeshow: false, // 表示是否显示充电图标
      batteryshow: true, //表示当前能获取到电池状态
      systemDrawer: false,
      hardDrawer: false,
      Noteven: false,
      statusVs: {} as any, // 系统版本
      statusDstic: [], // 硬件状态
      statusDsticOBJ: {} as any,
      websocketUrl: process.env.VUE_APP_WEBSOCKET_URL,
      rankingListData: [
      ] as any,
      dayslist: [{
        text: _t('public.lastSevenDays'),
        days: 7
      }, {
        text: _t('public.lastFourteenDays'),
        days: 14
      },
      {
        text: _t('public.lastThirtyDays'),
        days: 30
      }],
      defaultdays: 0,
      onlineStatus: false,
      onlinecolorFlag: false,
      offlineStatus: false,
      offlinecolorFlag: false,
      leaveflag: false,
      leavecolorflag: false,
      notActiveflag: false,
      notActivecolorflag: false,
      downloadlog:false,
      checked1:true,
      checked2:true,
      checked3:true,
      checked4:false,
      checklogdown:false,
      logStartTime: null as any,
      logEndTime: null as any,
      logStartHour: null as any,
      logEndHour: null as any,
      momentStamp:momentStamp,
      hourList: hourList(),
      loadinglog:false,
      logpercentage:0,
      feedbackflg:false,
      logstatus:'',
      resultstatus:'',
      downurls:'',
      logtimes:null as any,
      interval:null as any,
      cancallogid: '' as number|string, 
      totalTasks: '',
      LoadingOptions: {
      
      },
      RefreshErrorTips: true,
      RefeshFlag: false,
      num: 0,
      ad_names:'',
      codecount:0,
      labelChange(){
        state.form.name = state.form.name.trim()
      },
      labelInput(){
        // state.form.name = inputRules(state.form.name)
        state.form.name = inputLengthLimit(state.form.name,20)
      },
      sim_query(){
        let params = {
          sn: state.robotData.sn
        }
        robotSIM(params).then((res: any) => {
          state.flow_calculation(res)
        }).catch(() => {
          state.robtBasicsInfo.id_number = '-1'
        })
      },
      flow_calculation(res:any){
        let num1:any = res.data.cloud_sum / 1024 / 1024
        let num2:any = res.data.month_sum / 1024 / 1024
        let integer1 = num1 / 1024
        let integer2 = num2 / 1024
        if(res.data.cloud_sum == 0){
          state.robtBasicsInfo.cloud_sum = num1 + 'MB'
        }else if(integer1 % 1 == 0){
          state.robtBasicsInfo.cloud_sum  = integer1 + 'G'
        }else if(num1 > 1024){
          let g:any = num1 / 1024 
          let mb:any = num1 % 1024
          state.robtBasicsInfo.cloud_sum = parseInt(g) + 'G' + Math.ceil(mb) + 'MB'
        }else if(num1 < 1024){
          state.robtBasicsInfo.cloud_sum = num1.toFixed(2) + 'MB'
        }

        
        if(res.data.month_sum == 0){
          state.robtBasicsInfo.month_sum = num2 + 'MB'
        }else if(integer2 % 1 == 0){
          state.robtBasicsInfo.month_sum  = integer2 + 'G'
        }else if(num2 > 1024){
          let g:any = num2 / 1024 
          let mb:any = num2 % 1024
          state.robtBasicsInfo.month_sum = parseInt(g) + 'G' + Math.ceil(mb) + 'MB'
        }else if(num2 < 1024){
          state.robtBasicsInfo.month_sum = num2.toFixed(2) + 'MB'
        }
        state.robtBasicsInfo.id_number = res.data.id_number

      },
      refresh(){
        state.RefeshFlag = true
        ElLoading.service(state.LoadingOptions)
        state.refresh_init()
      },
      count_fn(){
        state.num = ++state.num
      },
      // 多语言适配
      checkDaysLanguageStyle() {
        let getlanguage = getLanguage()
        if(getlanguage == 'en'){
          state.languageClassObj.enStyle = true
          state.languageClassObj.koStyle = false
          state.languageClassObj.deStyle = false
          state.languageClassObj.frStyle = false
          state.languageClassObj.jaStyle = false
          state.languageClassObj.nlStyle = false
          state.languageClassObj.plStyle = false
          return '300px'
        }else if(getlanguage == 'zh-cn'){
          state.languageClassObj.enStyle = false
          state.languageClassObj.koStyle = false
          state.languageClassObj.deStyle = false
          state.languageClassObj.frStyle = false
          state.languageClassObj.jaStyle = false
          state.languageClassObj.nlStyle = false
          state.languageClassObj.plStyle = false
          return '180px'
        }else if(getlanguage == 'ko'){
          state.languageClassObj.enStyle = false
          state.languageClassObj.koStyle = true
          state.languageClassObj.deStyle = false
          state.languageClassObj.frStyle = false
          state.languageClassObj.jaStyle = false
          state.languageClassObj.nlStyle = false
          state.languageClassObj.plStyle = false
          return '280px'
        }else if(getlanguage == 'de'){
          state.languageClassObj.enStyle = false
          state.languageClassObj.koStyle = false
          state.languageClassObj.deStyle = true
          state.languageClassObj.frStyle = false
          state.languageClassObj.jaStyle = false
          state.languageClassObj.nlStyle = false
          state.languageClassObj.plStyle = false
          return '280px'
        }else if(getlanguage == 'fr'){
          state.languageClassObj.enStyle = false
          state.languageClassObj.koStyle = false
          state.languageClassObj.deStyle = false
          state.languageClassObj.frStyle = true
          state.languageClassObj.jaStyle = false
          state.languageClassObj.nlStyle = false
          state.languageClassObj.plStyle = false
          return '300px'
        }else if(getlanguage == 'ja'){
          state.languageClassObj.enStyle = false
          state.languageClassObj.koStyle = false
          state.languageClassObj.deStyle = false
          state.languageClassObj.frStyle = false
          state.languageClassObj.jaStyle = true
          state.languageClassObj.nlStyle = false
          state.languageClassObj.plStyle = false
          return '180px'
        }else if(getlanguage == 'nl'){
          state.languageClassObj.enStyle = false
          state.languageClassObj.koStyle = false
          state.languageClassObj.deStyle = false
          state.languageClassObj.frStyle = false
          state.languageClassObj.jaStyle = false
          state.languageClassObj.nlStyle = true
          state.languageClassObj.plStyle = false
          return '280px'
        }else if(getlanguage == 'pl'){
          state.languageClassObj.enStyle = false
          state.languageClassObj.koStyle = false
          state.languageClassObj.deStyle = false
          state.languageClassObj.frStyle = false
          state.languageClassObj.jaStyle = false
          state.languageClassObj.nlStyle = false
          state.languageClassObj.plStyle = true
          return '280px'
        }else {
          return '220px'
        }
      },
      popover_width(){
        let getlanguage = getLanguage()
        if(getlanguage == 'en'){
          return 300
        }else if(getlanguage == 'zh-cn'){
          return 200
        }else if(getlanguage == 'de'){
          return 320
        }else if(getlanguage == 'fr'){
          return 320
        }else if(getlanguage == 'pl'){
          return 350
        }else {
          return 300
        }
      },
      setLimitTime () {
        clearTimeout(state.interval)  // 先清除
        state.interval = setTimeout(function () {
          console.log('超1分钟未接收到消息')
          state.canclebtn()
        }, 60000)
      },
      ondownloadlog() {
        if (!state.onlineStatus) {
           ElMessage({
                message: _t('robot.robotisofflineobtalogs'),
                type: "error",
              })
          return
        }
        state.getlastlogs()
        state.downloadlog = true
      },
      // 为日历控件 禁用规则
      disabledDate (time:any) {
        // return state.logEndTime ? time.getTime() > state.logEndTime : time.getTime() > moment().subtract(0, 'days')
        if (state.logEndTime) {
          return time.getTime() > state.logEndTime ||  state.logEndTime > time.getTime()+6*24*3600*1000
        } else {
          return time.getTime() > moment().subtract(0, 'days')
        }
      },
      disabledDate2 (time:any) {
        // console.log((time.getTime()-state.logStartTime)/1000/24/3600)
        if (state.logStartTime) {
          return  state.logStartTime > time.getTime() || time.getTime() > moment().subtract(0, 'days') || time.getTime()-6*24*3600*1000 > state.logStartTime
        } else {
          return time.getTime() > moment().subtract(0, 'days')
        }
        // return state.logStartTime ?
        //   state.logStartTime > time.getTime() || time.getTime() > moment().subtract(0, 'days')
        //   : time.getTime() > moment().subtract(0, 'days')
      },
      // 取消上传日志并返回
      canclebtn() {
        cancellogs({
          sn:state.robtBasicsInfo.sn,
          logid: Number(sessionStorage.getItem('hsaloguuid'))
        }).then(res=>{
          console.log('日志取消结果',res)
        })
        console.log('日志111')
        state.cancallogid = Number(sessionStorage.getItem('hsaloguuid'))
        clearTimeout(state.interval)  
        state.logstatus = ''
        state.resultstatus = 'cancel'
        state.logtimes =  new Date()
        state.loadinglog = false
        state.feedbackflg = true
      },
      trimbtn() {
        // 点击 获取 表单校验 通过发送请求
           let formflge = true
           state.checklogdown = true
           unref(userFormRef).validate((valid:any) => {
            if (valid) {
            } else {
              formflge = false
            }
          })
          if (!formflge) {
            state.checklogdown = false
            return
          } else {
            formflge = false
          }
          let logtyeps = [] 
          if (state.checked1) {
             logtyeps.push('android')
          }
          if (state.checked2) {
            logtyeps.push('mainctl')
          }
          if (state.checked3) {
            logtyeps.push('mcu')
          }
          if (state.checked4) {
            logtyeps.push('navi')
          }
        const {
          logStartTime,
          logEndTime,
          logStartHour,
          logEndHour,
        } = state;
         if (logEndTime.getTime() + Number(logEndHour) * 3600 <= logStartTime.getTime() + Number(logStartHour) * 3600) {
          ElMessage({
                message: _t('robotinfo.Nologtime'),
                type: "error",
          })
          return
        }
        // 生成ID并存储  
          const logid = Number(state.rnd(new Date().getTime())) * 1
          state.loadinglog = true
          sessionStorage.setItem('hsaloguuid', String(logid))
          state.logpercentage = 0
          state.cancallogid = ''
          getlogs({
          sn: state.robtBasicsInfo.sn,
          type:logtyeps.toString(),
          start: logStartTime.getTime() + Number(logStartHour) * 3600 * 1000,
          end: logEndTime.getTime() + Number(logEndHour) * 3600 * 1000,
          // start:1676883600000,
          // end:1676887200000,
          logid,
          }).then((res:any)=>{
            if (res.code == 200) {
              // 开启延时器一分钟没有则认为超时 发送取消获取日志
              state.setLimitTime()
              state.loadinglog = true
            } else if (res.code == 100) {
              ElMessage({
                message: _t('robotinfo.Nologtime'),
                type: "error",
              })
              state.loadinglog = false
            } else if (res.code == 201) {
              ElMessage({
                message: _t('robotinfo.logtaskispackagedpackged'),
                type: "error",
              })
              state.loadinglog = false
            }  else {
              ElMessage({
                message: _t('robotinfo.failtoget'),
                type: "error",
              })
              state.loadinglog = false
            }
          }).catch((err:any)=>{
            console.log(err,state.cancallogid,sessionStorage.getItem('hsaloguuid'),'错误信息',state.cancallogid&&state.cancallogid != Number(sessionStorage.getItem('hsaloguuid')))
            if (state.cancallogid&&state.cancallogid != Number(sessionStorage.getItem('hsaloguuid'))) {
              return
            }
             ElMessage({
                message: _t('robotinfo.failtoget'),
                type: "error",
              })
             state.loadinglog = false
          })
        },
        // 获取 上传状态中 不等于finish并且不为1/2 2/2 表示上传失败 finish不显示进度页面
       getresultmsg(msg:string){
          if (msg == '1/2') {
            return _t('robotinfo.Failedtopackage1/2')
          } else if (msg == '2/2') {
            return _t('robotinfo.Failedtopackage2/2')
          } else if (msg != 'finish') {
            return _t('robotinfo.failtoupload')
          }
       },
       // 关闭日志弹框
       cancelLogDialog () {
        state.downloadlog = false;
        state.logStartTime = undefined;
        state.logEndTime = undefined;
        state.logStartHour = undefined;
        state.logEndHour = undefined;
        state.checked1 = true
        state.checked2 = true
        state.checked3 = true
        // state.loading = false;
      },
      handleClose() {
        state.robotBindDialog = false
      },
      robotBindDialogOpen() {
        state.robotBindDialog = true
        let building_id = state.robtBasicsInfo.building_id
        let shop_id = state.robtBasicsInfo.shop_id
        //   state.buildingShopData[0].children.forEach((item: any) => {
        //     if(building_id == item.id){
        //       item.disabled = true
        //     }else {
        //       item.disabled = false
        //     }
        //  });

          state.buildingShopData[0].children.forEach((item: any) => {
            if(shop_id == item.id){
              item.disabled = true
            }else {
              item.disabled = false
            }
         });
      
      },
      dialogclose() {
        state.robotBindDialog = false
        state.cascaderValue = ''
      },
      selectTrigger() {
      },
      nameDialogOpen(){
        state.form.name = ''
        state.dialogFormVisible = true
        state.form.name = state.robtBasicsInfo.nick_name
      },
      confirm() {
        // 解绑店铺或楼栋
        if (state.robtBasicsInfo.building_id != '0') {
          buildingRobotDelete({ robots: state.robtBasicsInfo.id }).then((res: any) => {
    
            if (res.code != 200) {
              ElMessage.error(`${res.msg}`)
            }
            state.buildingAndShop_binding()
          })
        } else if (state.robtBasicsInfo.shop_id != '0') {
          shopRobotDelete({ robots: state.robtBasicsInfo.id }).then((res: any) => {
           
            if (res.code != 200) {
              ElMessage.error(`${res.msg}`)
            }
            state.buildingAndShop_binding()
          })
        }else {
          state.buildingAndShop_binding()
        }
      },
      buildingAndShop_binding(){
        // 楼栋绑定
        if (state.cascaderValue[0] == 'building') {
          state.robotRelationParams.building_id = state.cascaderValue[1]
          state.robotRelationParams.robots = state.robtBasicsInfo.id
          relationRobots(state.robotRelationParams).then((res: any) => {
          
            if (res.code == 200) {
              ElMessage({
                message: _t('robot.bindingSuccess'),
                type: "success",
              })
              state.init()
            }else if(res.code == 10019){
              ElMessage.error(_t('robot.buildingRobotErrorTips_10019'))
            }else if(res.code == 10020){
              ElMessage.error(_t('robot.buildingRobotErrorTips_10020'))
            }else if(res.code == 10021){
              ElMessage.error(_t('robot.robot_does_not_exist'))
            } else if(res.code == 10022){
              ElMessage.error(_t('robot.robot_current_enterprise'))
            } else {
              ElMessage.error(`${res.msg}`)
            }
            state.robotBindDialog = false
          })
        }
        // 店铺绑定
        else {
          state.shopRelationParams.shop_id = state.cascaderValue[1]
          state.shopRelationParams.robots = state.robtBasicsInfo.id
          shopRobotUpdate(state.shopRelationParams).then((res: any) => {
       
            if (res.code == 200) {
              ElMessage({
                message: _t('robot.bindingSuccess'),
                type: "success",
              })
              state.init()
            }else if(res.code == 10019){
              ElMessage.error(_t('robot.buildingRobotErrorTips_10019'))
            }else if(res.code == 10020){
              ElMessage.error(_t('robot.buildingRobotErrorTips_10020'))
            }else if(res.code == 10021){
              ElMessage.error(_t('robot.robot_does_not_exist'))
            } else if(res.code == 10022){
              ElMessage.error(_t('robot.robot_current_enterprise'))
            } else {
              ElMessage.error(`${res.msg}`)
            }
            state.robotBindDialog = false
          })
        }
      },
      getData() {
        let params = {
          name: '',
          pageSize: '',
          page: '',
          limit: false
        }
   
        // 楼宇查询
        // buildingListRequest(params).then((res: any) => {
          
        //   res.data.list.map((item: any) => {
        //     item.label = item.name
        //     item.value = item.id
        //   })
        //   state.buildingShopData[0].children = res.data.list
        // })
        // 店铺查询
        shopQuery(null).then((res: any) => {
          
          res.data.map((item: any) => {
            item.label = item.name
            item.value = item.id
          })
          state.buildingShopData[0].children = res.data
        })
      },
      openWebsocket() {

        const params = {
          robotsn: state.robtBasicsInfo.sn,
          topic: "notify",
          unsubscribe: false,
        };
       
        const val = JSON.stringify(params);
        if ("WebSocket" in window) {
          // websocket = new WebSocket(state.websocketUrl)

          websocket = new WebSocket(
            state.websocketUrl + "?token=" + useStore().state.user.token
          );
        } else {
    
        }
        //成功回调
        websocket.onopen = function (event: any) {
          console.log('连接成功')
          websocket.send(val);
        
        };
        //事件监听
        websocket.onmessage = function (event: any) {
          // console.log('websocket监听数据', event)
        
          if (event.data == "ping") {
            websocket.send("pong");
            return;
          }
          let websocketData = JSON.parse(event.data)
          
          console.log('websocketData',websocketData)
          if (websocketData.title == 'carbot_online_info') {  //在线状态数据

            if (websocketData.content.online) {
              state.robotState = _t('robotState.online')
              state.onlineStatus = true
              state.onlinecolorFlag = true
              state.offlineStatus = false
              state.offlinecolorFlag = false
              state.leaveflag = false
              state.leavecolorflag = false
            } else {
              state.robotState = _t('robotState.offline')
              state.onlineStatus = false
              state.onlinecolorFlag = false
              state.offlineStatus = true
              state.offlinecolorFlag = true
              state.leaveflag = false
              state.leavecolorflag = false
            }

          } else if (websocketData.title == 'carbot_system_status') {  //系统状态
            // // 系统版本-语言
            // state.language = websocketData.content.language
            
            if (websocketData.content.battery_info) {
              state.Batterys = websocketData.content.battery_info.level
              state.robtBasicsInfo.battery_info = websocketData.content.battery_info
              // 动态改变电池颜色
              if (state.Batterys >= 1 && state.Batterys < 20) {
                state.BackGroundcolor = '#F5222D'
              } else if (state.Batterys >= 20 && state.Batterys < 60) {
                state.BackGroundcolor = 'rgba(219,165,55)'
              } else if (state.Batterys >= 60) {
                state.BackGroundcolor = '#52C41A'
              }

                // 是否充电 显示充电图标
                if (state.robtBasicsInfo.battery_info.status == 1 || state.robtBasicsInfo.battery_info.status == 2) {
                state.chargeshow = true
              } else {
                state.chargeshow = false
              }
            }
            websocketData.content.ad_name?state.ad_names = websocketData.content.ad_name:''
          } else if (websocketData.title == 'carbot_diagnostic_info') {  // 硬件状态
            websocketData.content.map((el: any) => {
              Object.values(state.statusDsticOBJ).forEach((item: any) => {
                if(el.key == item.key){
                  item = el
                }
              })
              state.statusDsticOBJ = Object(state.statusDsticOBJ)
            });
            
          }else if (websocketData.title == 'carbot_system_version') {  // 系统版本
                // 系统版本-语言
                state.language = websocketData.content.language
          }
           else if (websocketData.title == 'carbot_work_status') {   //机器人工作状态
            // 工作中 空闲等。。。
            switch (websocketData.content.work_status) {
              case "":
                state.stateContent = _t('robotState.unknown') // '未知'
                state.stateSizeColorTwo = 'rgba(0,0,0,0.25)'
                state.stateColorTwo = 'rgba(0,0,0,0.1)'
                state.stateBorderColorTwo = '1px solid rgba(0,0,0,0.25)'
                break
              case 'idle':
                state.stateContent = _t('robotState.free') // '空闲'
                state.stateSizeColorTwo = '#52C41A'
                state.stateColorTwo = 'rgba(82, 196, 26, 0.15)'
                state.stateBorderColorTwo = '1px solid #52C41A'
                break
              case 'busy':
                state.stateContent = _t('robotState.atWork') // '工作中'
                state.stateSizeColorTwo = '#1890FF'
                state.stateColorTwo = 'rgba(24, 144, 255, 0.15)'
                state.stateBorderColorTwo = '1px solid #1890FF'
                break
              case 'charging': 
                state.stateContent = _t('robotState.charge') // '充电'
                state.stateSizeColorTwo = '#FAAD14'
                state.stateColorTwo = 'rgba(250,173,20,0.15)'
                state.stateBorderColorTwo = '1px solid #FAAD14'
                break
              case 'pause':
                state.stateContent = _t('robotState.workSuspension') // '工作暂停'
                state.stateSizeColorTwo = '#1890FF'
                state.stateColorTwo = 'rgba(24, 144, 255, 0.15)'
                state.stateBorderColorTwo = '1px solid #1890FF'
                break
            }
          } else if (websocketData.title == 'notify_file_upload') { //监听下载title
          // 判断点击获取日志时候 存储的ID是不是 websocket推送过来的 对比
            if (websocketData.content.uuid == sessionStorage.getItem('hsaloguuid')) {
              // 接受值渲染最新数据
              // 首先获取各状态 任务中 结束 完成时候
              if (websocketData.content.status == 'start'||websocketData.content.status == '1/2'||websocketData.content.status == '2/2') {
                // 有这三种消息先关闭延时器在启动
                state.setLimitTime()
                state.loadinglog = true
                state.logpercentage = websocketData.content.persentage
                state.logstatus = websocketData.content.status 
              } else if (websocketData.content.status == 'finish') {
                clearTimeout(state.interval)
                state.loadinglog = false
                state.feedbackflg = true
                state.logstatus = ''
                state.resultstatus = websocketData.content.status
                state.downurls = websocketData.content.url
                state.logtimes =  websocketData.timestamp
              } else if (websocketData.content.status=='cancel'||websocketData.content.status=='fail') {
                clearTimeout(state.interval)
                state.loadinglog = false
                state.feedbackflg = true
                state.logstatus = ''
                state.resultstatus = websocketData.content.status
                state.logtimes =  websocketData.timestamp
              }
          }
          }else if(websocketData.title == 'carbot_notify_sim_info'){ // SIM卡
            let num1 = websocketData.content.cloud_sum / 1024 / 1024
            let num2 = websocketData.content.month_sum / 1024 / 1024
            let integer1 = num1 / 1024
            let integer2 = num2 / 1024
            if(websocketData.content.cloud_sum){
              state.robtBasicsInfo.cloud_sum = num1 + 'MB'
            }else if(integer1 % 1 == 0){
              state.robtBasicsInfo.cloud_sum  = integer1 + 'G'
            }else if(num1 > 1024){
              let g:any = num1 / 1024 
              let mb:any = num1 % 1024
              state.robtBasicsInfo.cloud_sum = parseInt(g) + 'G' + Math.ceil(mb) + 'MB'
            }else if(num1 < 1024){
              state.robtBasicsInfo.cloud_sum = num1.toFixed(2) + 'MB'
            }

            if(websocketData.content.month_sum){
              state.robtBasicsInfo.month_sum = num2 + 'MB'
            }else if(integer2 % 1 == 0){
              state.robtBasicsInfo.month_sum  = integer2 + 'G'
            }else if(num2 > 1024){
              let g:any = num2 / 1024 
              let mb:any = num2 % 1024
              state.robtBasicsInfo.month_sum = parseInt(g) + 'G' + Math.ceil(mb) + 'MB'
            }else if(num2 < 1024){
              state.robtBasicsInfo.month_sum = num2.toFixed(2) + 'MB'
            }
            state.robtBasicsInfo.id_number = websocketData.content.id_number
          }
        };
        websocket.onclose = function (e:any) {
          console.log(e,'关闭时候重连时候',e.code)
          if (e.code == 1006) {
               state.codecount++
               console.log(state.codecount)
          }
          if (state.Noteven ||state.codecount >= 6) {
            console.log("我已经关闭了websocket");
            state.codecount = 0
            return;
          }
          state.openWebsocket();
        };
      },
      // 复制
      onCopy() {
        let ONCOPY: any = document.getElementById('copy')
        let createRange = document.createRange()
        createRange.selectNodeContents(ONCOPY)
        const selection: any = document.getSelection()
        selection.removeAllRanges()
        selection.addRange(createRange)
        document.execCommand('Copy')
        selection.removeAllRanges()
        ElMessage({
          message: '复制成功',
          type: 'success',
        })
      },
      switchDays(day: number, index: number) {
        if (state.defaultdays == index) {
          return
        }
        state.defaultdays = index
        state.getWorktime(day)
      },
      // 任务占比
      getTask() {
        let params = {
          sn: state.robotData.sn, 
        }
        getTask(params).then((res: any) => {
          state.totalTasks = res.data.task_num
          if(res.data.state_num){
            res.data.state_num.forEach((item: any) => {
            let taskObj = {} as any
              item.new_state = item.state
              if (item.state == 1) {
                item.state = _t('robotState.executing') // '进行中'
              } else if (item.state == 3) {
                item.state = _t('robotState.Completed') // '完成'
              } else if (item.state == 4) {
                item.state = _t('robotState.nobodyTakesThings') // '无人取物'
              } else if (item.state == 5) {
                item.state = _t('robotState.abnormalEnd') // '异常结束'
              }else if (item.state == 6) {
                item.state = _t('disinfect.Manualcancellation') // 手动取消
              }
              taskObj.value = item.num
              taskObj.name = item.state
              taskObj.new_state = item.new_state
              state.taskArr.push(taskObj)
          })
         
          }else {
            state.taskArr = []
          }
          state.circular = true
        })

      },
      // 楼宇配送次数排行榜
      getbuildingOrder() {
        let params = {
          sn: state.robotData.sn,
          day: -1
        }

        getbuildingOrder(params).then((res: any) => {

          res.data.forEach((item:any) => {
            if(item.destination === '---'){
              item.destination = '巡游'
            }
          })
          state.rankingListData = res.data
        })
      },
      // 获取工作时间趋势
      getWorktime(day: number) {
        state.workTimeArr = []
        state.workDayArr = []
        let params = {
          sn: state.robotData.sn,
          day: day,
        }
        getWorktime(params).then((res: any) => {
          state.lineChart = false
          if (res.data.stat_day) {
            res.data.stat_day.forEach((item: any) => {
              state.workTimeArr.push(item.date)
              state.workDayArr.push(item.stat_time)
            })
          } else {
            state.workTimeArr = [0, 0, 0, 0, 0, 0, 0]
            state.workDayArr = [0, 0, 0, 0, 0, 0, 0]
          }
          state.workTimeMax = Math.max(...state.workDayArr)
          state.lineChart = true
        })
      },
      systemDrawerClose() {
        state.systemDrawer = false
      },
      hardDrawerClose() {
        state.hardDrawer = false
      },
      robtoUpdate() {
        if(!state.form.name){
          return
        }
        let params = {
          nick_name: state.form.name.trim(),
          status: ''
        }
        robotsUpdateName(params, state.robotData.id).then((res: any) => {
          state.dialogFormVisible = false
          state.init()
          ElMessage({
            message: _t('robot.setLabel'),
            type: 'success',
          })
        })
      },
      getActiveCode() {
        let params = {
          sn: state.robotData.sn
        }
        robotsActiveCode(params).then((res: any) => {
          state.robtBasicsInfo.active_code = res.data.active_code
        })
      },
      // 获取最新数据
      refresh_StatusVs(){
        let params = {
          sn: state.robotData.sn
        }
        refresh_version(params).then((res: any) => {
          state.statusVs = res.data
          state.language = state.statusVs.language
          state.refresh_StatusDstic()
        }).catch((res) => {
          state.count_fn()
          state.refresh_StatusDstic()
          state.RefreshErrorTips = false
        })
        
      },
      refresh_StatusDstic(){
        let params = {
          sn: state.robotData.sn
        }
        refresh_diag(params).then((res: any) => {
          state.statusDstic = res.data
          state.statusDstic.forEach((item: any) => {
            state.statusDsticOBJ[item.key] = item
          })
          ElLoading.service().close()
          state.refresh_tips()
        }).catch((res) => {
          state.count_fn()
          state.RefreshErrorTips = false
          ElLoading.service().close()
          state.refresh_tips()
        })

      },
      refresh_tips(){
        // 点击刷新按钮提示成功或失败
        if(state.RefeshFlag){
          // 全部失败
          if(state.num == 3){
            ElMessage({
                message: _t('robot.update_failed'),
                type: "error",
              })
          }else {
            if(state.RefreshErrorTips){
              ElMessage({
                  message: _t('robot.update_robot_datasSuccess'),
                  type: "success",
                })
            }else{
              ElMessage({
                  message: _t('robot.Partial_information_update_failed'),
                  type: "error",
                })
            }
          }

          state.num = 0
          state.RefeshFlag = false
          state.RefreshErrorTips = true
        }
      },
      // 获取系统版本（缓存数据）
      getStatusVs() {
        let params = {
          sn: state.robotData.sn
        }
        getStatusVs(params).then((res: any) => {
          state.statusVs = res.data
          state.language = state.statusVs.language
          // if(state.statusVs.language == 'zh'){  // 韩语、日语、德语、法语、波兰语、荷兰语
          //   state.language = '中文'
          // }else if(state.statusVs.language == 'en'){
          //   state.language = '英文'
          // }else if(state.statusVs.language == 'de'){
          //   state.language = '德语'
          // }else if(state.statusVs.language == 'fr'){
          //   state.language = '法语'
          // }else if(state.statusVs.language == 'pl'){
          //   state.language = '波兰语'
          // }else if(state.statusVs.language == 'nl'){
          //   state.language = '荷兰语'
          // }
        })
        state.getStatusDstic()
      },
      // 获取硬件状态
      getStatusDstic() {
        let params = {
          sn: state.robotData.sn
        }
        getStatusDstic(params).then((res: any) => {
          state.statusDstic = res.data
          state.statusDstic.forEach((item: any) => {
            state.statusDsticOBJ[item.key] = item
          })
        })   
      },
      refresh_init(){
        state.robotData = JSON.parse(sessionStorage.getItem('robotData') as any)
        let params = {
          sn: state.robotData.sn
        }
        refresh_info(params).then((res: any) => {
          state.robtBasicsInfo = res.data
          state.flow_calculation(res)
          state.init_content()
          state.refresh_StatusVs()
        }).catch((res: any) => {
          state.count_fn()
          state.refresh_StatusVs()
          state.RefreshErrorTips = false
        })

      },
      init() {
        state.robotData = JSON.parse(sessionStorage.getItem('robotData') as any)
        let params = {
          sn: state.robotData.sn
        }
        robotsInfo(params).then((res: any) => {
          state.robtBasicsInfo = res.data
          state.ad_names = res.data.ad_name
          state.init_content()
          state.sim_query()

        })
        robotsWorkData(params).then((res: any) => {
          res.data.last_online = Number(res.data.last_online * 1000)
          // res.data.last_online = formatTime("YYYY-mm-dd HH:MM:SS", res.data.last_online)
          res.data.last_online =res.data.last_online>0? moment(res.data.last_online).format(momentStamp('dateTime')):'-'
          res.data.sum_online_time = timeBlankSpaceFormat(res.data.sum_online_time)
          res.data.sum_delivery_time = timeBlankSpaceFormat(res.data.sum_delivery_time)
          res.data.sum_lead_time = timeBlankSpaceFormat(res.data.sum_lead_time)
          state.operatingData = res.data
        })
        state.getStatusVs()
      },
      init_content(){
          // 超出字数省略号显示
          // 超出字数省略号显示
          if (state.robtBasicsInfo.building_name.length > 12) {
            state.robtBasicsInfo.building_name_show = state.robtBasicsInfo.building_name.substr(0, 11) + '...'
          } else {
            state.robtBasicsInfo.building_name_show = state.robtBasicsInfo.building_name
          }
          if (state.robtBasicsInfo.shop_name.length > 12) {
            state.robtBasicsInfo.shop_name_show = state.robtBasicsInfo.shop_name.substr(0, 11) + '...'
          } else {
            state.robtBasicsInfo.shop_name_show = state.robtBasicsInfo.shop_name
          }


          if (state.robtBasicsInfo.battery_info) {
            state.Batterys = state.robtBasicsInfo.battery_info.level
          }
          // 电量
          if (state.robtBasicsInfo.battery_info != null) {
            // 是否充电 显示充电图标
            if (state.robtBasicsInfo.battery_info.status == 1 || state.robtBasicsInfo.battery_info.status == 2) {
              state.chargeshow = true
            } else {
              state.chargeshow = false
            }
            if (state.Batterys >= 1 && state.Batterys < 20) {
              state.BackGroundcolor = '#F5222D'
            } else if (state.Batterys >= 20 && state.Batterys < 60) {
              state.BackGroundcolor = 'rgba(219,165,55)'
            } else if (state.Batterys >= 60) {
              state.BackGroundcolor = '#52C41A'
            }
          }

          // 在线 离线 已离开
          if (state.robtBasicsInfo.status != 'binded') {
            state.robotState = _t('robotState.hasLeft')
            state.onlineStatus = false
            state.onlinecolorFlag = false
            state.offlineStatus = false
            state.offlinecolorFlag = false
            state.leaveflag = true
            state.leavecolorflag = true
            state.notActiveflag = false
            state.notActivecolorflag = false
          } else {
            if (state.robtBasicsInfo.active_time > 0) {
              if (state.robtBasicsInfo.online == false) {
                state.robotState = _t('robotState.offline')
                state.onlineStatus = false
                state.onlinecolorFlag = false
                state.offlineStatus = true
                state.offlinecolorFlag = true
                state.leaveflag = false
                state.leavecolorflag = false
                state.notActiveflag = false
                state.notActivecolorflag = false
              } else {
                state.robotState = _t('robotState.online')
                state.onlineStatus = true
                state.onlinecolorFlag = true
                state.offlineStatus = false
                state.offlinecolorFlag = false
                state.leaveflag = false
                state.leavecolorflag = false
                state.notActiveflag = false
                state.notActivecolorflag = false
              }
            } else {
              state.robotState = _t('robotState.notActive')
              state.onlineStatus = false
              state.onlinecolorFlag = false
              state.offlineStatus = false
              state.offlinecolorFlag = false
              state.leaveflag = false
              state.leavecolorflag = false
              state.notActiveflag = true
              state.notActivecolorflag = true

            }

          }

          // 工作中 空闲等。。。
          switch (state.robtBasicsInfo.work_status) {
            case "":
              state.stateContent = _t('robotState.unknown') // '未知'
              state.stateSizeColorTwo = 'rgba(0,0,0,0.25)'
              state.stateColorTwo = 'rgba(0,0,0,0.1)'
              state.stateBorderColorTwo = '1px solid rgba(0,0,0,0.25)'
              break
            case 'idle':
              state.stateContent = _t('robotState.free') // '空闲'
              state.stateSizeColorTwo = '#52C41A'
              state.stateColorTwo = 'rgba(82, 196, 26, 0.15)'
              state.stateBorderColorTwo = '1px solid #52C41A'
              break
            case 'busy':
              state.stateContent = _t('robotState.atWork') // '工作中'
              state.stateSizeColorTwo = '#1890FF'
              state.stateColorTwo = 'rgba(24, 144, 255, 0.15)'
              state.stateBorderColorTwo = '1px solid #1890FF'
              break
            case 'charging': 
              state.stateContent = _t('robotState.charge') // '充电'
              state.stateSizeColorTwo = '#FAAD14'
              state.stateColorTwo = 'rgba(250,173,20,0.15)'
              state.stateBorderColorTwo = '1px solid #FAAD14'
              break
            case 'pause':
              state.stateContent = _t('robotState.workSuspension') // '工作暂停'
              state.stateSizeColorTwo = '#1890FF'
              state.stateColorTwo = 'rgba(24, 144, 255, 0.15)'
              state.stateBorderColorTwo = '1px solid #1890FF'
              break
          }
          
          state.openWebsocket();
      },
      // 类似于UUID 用时间
      rnd (seed:any) {
        seed = (seed * 9301 + 49297) % 233280;
        return String(seed / (233280.0)).slice(2, 10);
      },
      // 获取最近的一次日志记录
      getlastlogs() {
        lastlogs({
          sn:state.robotData.sn
        }).then((res:any)=>{
           if (res.code == 200&&res.data) {
              state.feedbackflg = true
              state.resultstatus = res.data.status
              state.downurls = res.data.url
              state.logtimes = res.data.updated_at * 1000
           }
        })
      },
      // 点击下载 完成的日志
      clicklogsdown() {
        window.location.href = state.downurls
      }
    })

    const handleBack = () =>{
      router.push('/robot/robotList')
      sessionStorage.setItem('from','robotInfo')
    }

    watch(() => state.robotState,(newVal,oldVal) => {
      if(oldVal){
        location.reload()
      }
      console.log('旧数据',oldVal)
    })

    onMounted(() => {
      nextTick(() => {
        state.getbuildingOrder()
        state.getWorktime(7)
        state.getTask()
      })
      state.init()
      state.getData()
      // state.getActiveCode()
    })
    onBeforeUnmount(() => {
      state.Noteven = true;
      websocket.close();
    });

    // onDeactivated(() => {
    //   const yuanEcharts = init(document.getElementById('yuanEcharts') as HTMLDivElement)
    //   const lineCharts = init(document.getElementById('lineCharts') as HTMLDivElement)
    //   yuanEcharts.dispose()
    //   lineCharts.dispose()
    // })
    return {
      ...toRefs(state),
      debounce,
      userFormRef,
      moment,
      handleBack,
      getLanguage
      //   throttle
    };
  },
})

